import styled from "styled-components";

export const PageContainer = styled.div`
  text-align: center;
  padding: 2.5rem;

  @media (max-width: 600px) {
    padding: 1.5rem 1rem;
  }
`;

export const Card = styled.div`
  max-width: 31.25rem;
  margin: 2.5rem auto;

  @media (max-width: 600px) {
    margin: 1.5rem auto;
  }
`;

export const WideCard = styled(Card)`
  max-width: 43.75rem;
`;

export const Button = styled.button`
  cursor: pointer;
  font-size: 1rem;

  &:disabled {
    cursor: not-allowed;
  }
`;

export const TopBar = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 0.75rem;
`;

export const Spinner = styled.div`
  width: 2rem;
  height: 2rem;
  margin: 1.25rem auto;
  border: 0.25rem solid rgba(0, 0, 0, 0.15);
  border-top-color: #1a237e;
  border-radius: 50%;
  animation: spin 0.8s linear infinite;

  @keyframes spin {
    to {
      transform: rotate(360deg);
    }
  }
`;
